import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';

const PrivateRoute = ({ element: Element, ...rest }) =>
{
    const location = useLocation();

    // CRITICAL: Pass the page they TRIED to visit as a state or query param
    // We use 'encodeURIComponent' to ensure the URL is safe
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    
    const redirectTo = location.pathname.includes("business")
        ? `/login?returnUrl=${returnUrl}`
        : `/login?returnUrl=${returnUrl}`;

    return isAuthenticated() ? (
        <Element {...rest} />
    ) : (
        <Navigate to={redirectTo} replace />
    );
};

export default PrivateRoute;
